<template>
  <sfs-form-modal
    :id="modalId"
    size="md"
    title="Service Channel Work Order Photos to Push"
    @on-hide="resetFormData"
  >
    <imports-form
      description="Push work order photos to ServiceChannel."
      @on-submit="createServiceChannelWorkOrderPhotosPushImport"
      @on-save="handleSave"
      @on-cancel="closeModal"
      :key="formKey"
    >
      <template #downloads>
        <b-row>
          <b-col cols="12">
            <sfs-download-button
              label="Download Template"
              filename="Service Channel Work Orders Photos to Push Template.xlsx"
              :file-provider="$importsAPI.getServiceChannelWorkOrdersPhotosPushTemplate"
            />
          </b-col>
        </b-row>
      </template>
    </imports-form>
  </sfs-form-modal>
</template>

<script>
import ImportsForm from './Form.vue';
import formModalMixin from '@/mixins/formModalMixin';

export default {
  name: 'ServiceChannelWorkOrdersPhotosPushImportsAddModal',
  mixins: [formModalMixin],
  components: {
    ImportsForm,
  },
  data() {
    return {
      modalId: 'service-channel-work-orders-photos-push-imports-add-modal',
    };
  },
  methods: {
    createServiceChannelWorkOrderPhotosPushImport(data, handleCreate) {
      handleCreate(this.$importsAPI.serviceChannelWorkOrdersPhotosPushCreate(data));
    },
    handleSave(data) {
      if (this.$route.name != 'imports') {
        this.$router.push({ name: 'imports' });
      } else {
        this.closeModal();
      }
      this.$emit('on-save', data);
    },
  },
};
</script>
